/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'colorGradation'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'heightMillis'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'widthMillis'?: OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum];
export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum];


